import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import * as _ from 'lodash';

import { columns } from './product-columns';
import { BaseModalComponent } from 'shared/modal/_base-modal.component';
import { ProductsSearchComponent } from '../products-search/products-search.component';
import { ProductListsSearchComponent } from '../product-lists-search/product-lists-search.component';
import {ProductPanelComponent} from '../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'load-product-modal',
  templateUrl: 'load-product-modal.component.html',
  styleUrls: ['load-product-modal.component.scss'],
})
export class LoadProductModalComponent extends BaseModalComponent {

  @Output() productSelect: EventEmitter<any> = new EventEmitter();

  @ViewChild(ProductsSearchComponent, {static: false})
  productsSearch: ProductsSearchComponent | void;

  productResultColumns: Array<any> = columns;

  show() {
    super.show();
    _.defer(() => this.productsSearch && this.productsSearch.startSearch());
  }

  hide() {
    super.hide();
    if (this.productsSearch) {
      this.productsSearch.resetData();
    }
  }

  // handlers
  onProductSelect(row: any) {
    this.productSelect.emit(row);
    this.hide();
  }
}
